// extracted by mini-css-extract-plugin
module.exports = {"container":"cv-module--container--3UvHP","portraits":"cv-module--portraits--1NLJz"};